<template>
  <div class="container">
    <div class="content">
      <h2>🐾 Your Feline Friends 🐾</h2>
      <p><strong>Whisker Whispers from the Feline Realm</strong></p>

      Greetings, esteemed human! As connoisseurs of comfort and curators of cuddles, we, the feline overlords, are intrigued by your choices of companionship. Remember, just as a cat chooses its favorite spot in the sun, so too should you choose your companions wisely – whether they're of the furry kind or the human variety. Here's a glimpse into how we perceive your living arrangements:

      <h3>Your Clowder Constituents: Pet Preferences </h3>
      <div class="option" @click="selectOption('nopets')" :class="{ selected: isSelected('nopets') }">
        <span class="icon">🐾</span>
        <b>No pets - A curious choice, living without the refined company of pets. Are the whispers of the void too loud?</b>
      </div>
      
      <div class="option" @click="selectOption('dogs')" :class="{ selected: isSelected('dogs') }">
        <span class="icon">🐶</span>
        <b>Dogs - Loyal companions, indeed, but do they offer the same mysterious allure as a cat's enigmatic gaze?</b>
      </div>
      
      <div class="option" @click="selectOption('cats')" :class="{ selected: isSelected('cats') }">
        <span class="icon">😻</span>
        <b>Cats - Ah, a kindred spirit! Your home must be a bastion of grace, agility, and occasional disdainful stares.</b>
      </div>
      <div class="option" @click="selectOption('birds')" :class="{ selected: isSelected('birds') }">
        <span class="icon">🐦</span>
        <b>Birds - Feathered friends who serenade the dawn. Admirable, though they lack the dignified silence of a cat.</b>
      </div>
      <div class="option" @click="selectOption('alltypes')" :class="{ selected: isSelected('alltypes') }">
        <span class="icon">🐾💕</span>
        <b>All types - A heart as vast as a savannah, welcoming all creatures. A commendable, if exhausting, endeavor.</b>
      </div>
    </div>
  </div><br><br><br>
</template>
  
  <script>
  import { onboardingStore } from '@/components/stores/onboardingStore'; 
  
  export default {
    setup() {
      const store = onboardingStore();
  
      const selectOption = (option) => {
        // Set the selected option directly
        store.updateFormData({ own_pets: option });
      };
  
      // Helper method to check if an option is selected
      const isSelected = (option) => store.formData.own_pets === option;
      
  
      return { store, selectOption, isSelected };
    },
  };
  </script>
<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


button {
  grid-column: span 2;
  background-color: #4A148C; /* Dark purple */
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: black; /* Black background on hover */
}

.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>